export default __webpack_public_path__ + "static/media/selecta_big@2x.b23f9b3c.jpg";